<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>活动管理</el-breadcrumb-item>
      <el-breadcrumb-item>活动列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row :gutter="0">
        <el-col :span="12">
          <el-input
            placeholder="请输入查询内容"
            v-model="queryInfo.query"
            class="input-with-select"
            clearable
              style="width:300px;"
            @clear="gethuodongList"
            @change="gethuodongList"
          >
            <el-button slot="append" icon="el-icon-search" @click="gethuodongList"></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="addDialogVisible=true">添加活动</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="0" class="el_row_two">
        <el-col :span="24">
          <el-table :data="huodongList" style="width: 100%" border stripe>
            <!-- <el-table-column type="index" label="序号" width="80"></el-table-column> -->
            <el-table-column prop="uid" label=" 序号" width="80"></el-table-column>
            <el-table-column prop="huodong_name" label="活动编号" w></el-table-column>
            <el-table-column prop="huodong_name" label="活动名称" w></el-table-column>
            <el-table-column label="操作">
              <template v-slot="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="修改"
                  placement="top"
                  :enterable="false"
                >
                  <el-button
                    type="primary"
                    icon="el-icon-edit"
                    @click="showEditDialog(scope.row.uid)"
                    circle
                    size="mini"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="删除"
                  placement="top"
                  :enterable="false"
                >
                  <el-button
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    size="mini"
                    @click="deleteForm(scope.row.uid)"
                  ></el-button>
                </el-tooltip>

              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="queryInfo.pageNum"
        :page-sizes="[10,50]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
        <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
      </el-pagination>
      <!-- 添加活动部分 -->
      <el-dialog title="添加活动" :visible.sync="addDialogVisible" width="50%" @close="addDoalogClosed">
        <el-form ref="addFormRef" :model="addForm" :rules="addFormRules" label-width="100px">
          <el-form-item label="活动名称" prop="huodong_bianhao">
            <el-input v-model="addForm.huodong_bianhao"></el-input>
          </el-form-item>
          <el-form-item label="活动名称" prop="huodong_name">
            <el-input v-model="addForm.huodong_name"></el-input>
          </el-form-item>

          <el-form-item label="活动介绍" prop="huodong_demo">
            <el-input v-model="addForm.huodong_demo"></el-input>
          </el-form-item>

        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addhuodong">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 修改活动信息 -->
      <el-dialog
        title="修改活动信息"
        :visible.sync="editDialogVisible"
        width="50%"
        @close="editDoalogClosed"
      >
        <el-form ref="editFormRef" :model="editForm" :rules="addFormRules" label-width="100px">
          <el-form-item label="活动编号" prop="huodong_uid">
            <el-input v-model="editForm.huodong_uid" :disabled="true"></el-input>
          </el-form-item>

          <el-form-item label="活动名称" prop="huodong_name">
            <el-input v-model="editForm.huodong_name"></el-input>
          </el-form-item>

          <el-form-item label="活动管理人" prop="huodong_lxr">
            <el-input v-model="editForm.huodong_lxr"></el-input>
          </el-form-item>

          <el-form-item label="联系手机号" prop="huodong_mob">
            <el-input v-model="editForm.huodong_mob" max="11" min="10"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="updatehuodong">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
  import { checkMobileTest } from '../../tongyong/config/validator'
export default {
  data() {
    // var checkMobile = (rule, value, cb) => {
    //  const regMobil = /^(0|86|17951)?(13[0-9]|15[0123456789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
    // if (regMobil.test(value)) {
    //    return cb()
    //  }
    //  cb(new Error('请输入合法的手机号!'))
    //  }
    return {
      // 获取用户列表参数
      queryInfo: {
      //   token: window.sessionStorage.getItem('token'), // 递交数据，必须携带token ，进行验证
        C_type: 'get_list',
        C_table_name: 'huodong_list',
        query: '',
        pageNum: 1,
        pageSize: 10
      },
      huodongList: [],
      //  recordCount: 0,
      total: 0,
      addDialogVisible: false,
      editDialogVisible: false,
      //  添加表单数据项
      addForm: {
        C_type: 'huodong_add',
        huodong_bianhao: '',
        huodong_name: '',
        huodong_memo: ''
      },
      // 用于修改数据绑定
      editForm: {},
    // 表单规则项
      addFormRules: {

        huodong_name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
          { min: 1, max: 10, message: '必须1到10位字符 ', trigger: 'blur' }
        ],
        huodong_memeo: [
          { required: true, message: '请输入活动', trigger: 'blur' },
          { min: 1, max: 8000, message: '必须1到10位字符', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    this.gethuodongList();
  },
  methods: {
    async gethuodongList() {
      const { data: res } = await this.$http.get('get_api', {
        params: this.queryInfo
      });
            // console.log(JSON.parse(res.data))
      this.huodongList = JSON.parse(res.data)[0].dataList

       if (!this.huodongList) return
      this.huodongList.forEach(function(item) {
        item.yong_flag = item.yong_flag === 1;
      });

      this.total = JSON.parse(res.data)[0].total;

      // console.log(this.total);
    },
    //  分页第一项下拉触发

    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
     this.gethuodongList();
    },
    // 选择页数触发
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.gethuodongList();
    },
    addDoalogClosed() {
      this.$refs.addFormRef.resetFields();
    },
    addhuodong() {
     //  console.log(this.addForm)
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) return 1;
        const { data: res } = await this.$http.post('api', this.addForm);
        // console.log(JSON.parse(res.data)[0].status);
        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.error('添加失败');
          return
        }
        this.$message.success('添加成功');
        this.gethuodongList();
        this.addDialogVisible = false;
      });
    },
    showEditDialog(uid) {
      this.editDialogVisible = true;
      this.huodongInfo(uid);
    },
    editDoalogClosed() {
      this.$refs.editFormRef.resetFields();
    },
    async huodongInfo(uid) {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_table_name: 'huodong_info', uid: uid, C_type: 'get_info' }
      });
      // console.log(JSON.parse(res.data))
      console.log(res.data)
      if (JSON.parse(res.data)[0].status !== 200) {
        return this.$message.error('读取失败');
      }

      this.editForm = JSON.parse(res.data)[0].data[0];
    },
    async updatehuodong() {
      // console.log(123)
      this.$refs.editFormRef.validate(async valid => {
        if (!valid) return this.$message.error('验证错误！');
        const { data: res } = await this.$http.post('api', {
          C_type: 'huodong_update',
          huodong_uid: this.editForm.huodong_uid,
          huodong_name: this.editForm.huodong_name,
          huodong_lxr: this.editForm.huodong_lxr,
          huodong_mob: this.editForm.huodong_mob
        });

        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.error('更新失败');
          return;
        }
        this.$message.success('更新成功');
        this.gethuodongList();
        this.editDialogVisible = false;
      });
    },
    // 删除一条记录
    async  deleteForm(huodongUid) {
      // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
      // 异步操作有2个，1个对话框等待，1个是网络请求
           const comfirmResult = await this.$confirm('确定删除该条记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).catch(err => err)
        console.log(comfirmResult)
        if (comfirmResult === 'cancel') return this.$message.info('已经取消删除')
        const { data: res } = await this.$http.post('api', {
          C_type: 'record_delete',
          C_table_name: 'huodong_del',
          C_data1: huodongUid

        });
        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.error('删除失败');
          return;
        }
        this.$message.success('删除成功');
        this.gethuodongList();
    }
  }
};
</script>
<style lang="less" scoped>
.card_two {
  margin-top: 30px;
  box-shadow: none !important;
}
.el_row_two {
  margin-top: 30px;
}
</style>
